module.exports = __webpack_public_path__ + "img/install-devices-fr.c86acbed.png";